// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.1_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.1_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.error-500 {
  min-height: calc(100vh - 56px);
  display: flex;
}
.error-500 .wrapper {
  display: flex;
  flex-direction: row;
  width: 100%;
}
.error-500 .wrapper .text {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: var(--color_primary_500);
}
.error-500 .wrapper .text > * {
  max-width: 450px;
}
.error-500 .wrapper .text h1 {
  font-size: 2.875rem;
  margin: 0;
}
.error-500 .wrapper .text p:not(.sub-text) {
  margin: 0;
  font-size: 2.25rem;
}
.error-500 .wrapper .text .sub-text {
  color: var(--gray_dark2);
}
.error-500 .wrapper .text .refresh {
  text-decoration: underline;
}
.error-500 .wrapper .image {
  align-self: center;
  flex: 1 1;
  max-height: 500px;
  height: 100%;
}`, "",{"version":3,"sources":["webpack://./src/pages/ErrorPage/errors/e500/index.scss"],"names":[],"mappings":"AAEA;EACE,8BAAA;EACA,aAAA;AADF;AAGE;EACE,aAAA;EACA,mBAAA;EACA,WAAA;AADJ;AAGI;EACE,SAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,+BAAA;AADN;AAGM;EACE,gBAAA;AADR;AAIM;EACE,mBAAA;EACA,SAAA;AAFR;AAKM;EACE,SAAA;EACA,kBAAA;AAHR;AAMM;EACE,wBAAA;AAJR;AAOM;EACE,0BAAA;AALR;AASI;EACE,kBAAA;EACA,SAAA;EACA,iBAAA;EACA,YAAA;AAPN","sourcesContent":["@import 'src/vars';\n\n.error-500 {\n  min-height: calc(100vh - #{$header_height});\n  display: flex;\n\n  .wrapper {\n    display: flex;\n    flex-direction: row;\n    width: 100%;\n\n    .text {\n      flex: 1;\n      display: flex;\n      flex-direction: column;\n      justify-content: center;\n      align-items: center;\n      color: var(--color_primary_500);\n\n      &>* {\n        max-width: 450px;\n      }\n\n      h1 {\n        font-size: 2.875rem;\n        margin: 0;\n      }\n\n      p:not(.sub-text) {\n        margin: 0;\n        font-size: 2.25rem;\n      }\n\n      .sub-text {\n        color: var(--gray_dark2);\n      }\n\n      .refresh {\n        text-decoration: underline;\n      }\n    }\n\n    .image {\n      align-self: center;\n      flex: 1;\n      max-height: 500px;\n      height: 100%;\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
